<template>
	<div id="confirmationTake" class="px-3">
		<div class="row">
			<div class="col-12 pb-3 pl-0">
				<div class="col-12 bg-outline-purple rounded pt-3 pb-3">
					<div class="text-purple font-size-11" v-if="transactionOne.trx_shipping_method==0"><i class="fas fa-exclamation-circle mr-2"></i>Silahkan Konfirmasi Tanggal Pengambilan</div>
					<div class="text-purple font-size-11" v-if="transactionOne.trx_shipping_method==1"><i class="fas fa-exclamation-circle mr-2"></i>Silahkan Masukan Informasi Pengiriman</div>
					<div class="text-purple font-size-11 text-break" v-for="value in serialString" :key="value"><i class="fas fa-exclamation-circle mr-2"></i>{{ value }}</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="transactionOne.trx_shipping_method==1">
			<div class="col-12 col-md-12 pb-3 pl-0 pt-3">
				<div class="row">
					<div class="col-12 col-md-12 col-lg-4">
						Nomor Resi
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-3 col-md-6 pt-2">
						<input type="text" v-model="paramPickUp.shipping_courier_number" name="" class="form-control form-control-sm box-purple">
						<div class="invalid-feedback d-block m-0" v-if="AlertKonfPickUp.shipping_courier_number"> Nomor resi {{AlertKonfPickUp.shipping_courier_number}} </div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-12 pb-3 pl-0 pt-3">
				<div class="row">
					<div class="col-12 col-md-12 col-lg-4">
						Keterangan Mobile Counter
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-lg-3 col-md-6 pt-2">
						<textarea type="text" v-model="paramPickUp.shipping_courier_note_by_stockist" name="" class="form-control form-control-sm box-purple"></textarea>
						<div class="invalid-feedback d-block m-0" v-if="AlertKonfPickUp.shipping_courier_note_by_stockist"> Catatan {{AlertKonfPickUp.shipping_courier_note_by_stockist}} </div>
					</div>
				</div>
			</div>
		</div>
		<div class="row" v-if="transactionOne.trx_shipping_method==0">
			<div class="col-12 col-sm-12 col-md-6 pb-3 pl-0 pt-2">
				<div class="row">
					<div class="col-12 col-md-12">
						Tanggal Pengambilan
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 pt-2">
						<datepicker :language="indonesia" :disabled-dates="disabledDates" v-model="paramPickUp.taken_date" input-class="form-control font-size-sm-8 form-control-sm text-gray box-purple fullscreen-when-on-mobile" placeholder="Tanggal" bootstrap-styling>

						</datepicker>
						<div class="invalid-feedback d-block m-0" v-if="AlertKonfPickUp.taken_date"> Tanggal {{AlertKonfPickUp.taken_date}} </div>
					</div>
				</div>
			</div>
			<div class="col-12 col-sm-12 col-md-6 pb-3 pl-0 pt-2">
				<div class="row">
					<div class="col-12 col-md-12">
						Diambil Oleh
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 pt-2">
						<input type="text" v-model="paramPickUp.taken_by" name="" class="form-control form-control-sm box-purple">
						<div class="invalid-feedback d-block m-0" v-if="AlertKonfPickUp.taken_by"> Nomor resi {{AlertKonfPickUp.taken_by}} </div>
					</div>
				</div>
			</div>
			<div class="col-12 col-md-12 pb-2 pl-0 pt-2">
				<div class="row">
					<div class="col-12 col-md-12">
						Informasi
					</div>
				</div>
				<div class="row">
					<div class="col-12 col-md-12 pt-2 text-justify" v-if="transactionOne.trx_shipping_method==1">
						Jika Anda sudah melakukan pengiriman barang silahkan konfirmasi dihalaman ini agar pembeli dapat melihat proses transaksinya.
					</div>
					<div class="col-12 col-md-12 pt-2 text-justify" v-if="transactionOne.trx_shipping_method==0">
						Untuk mengonfirmasi bahwa barang sudah diambil harap pastikan pembeli sudah menerima produk sesuai pesanan, barang yang sudah diambil tidak dapat dikembalikan.
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Datepicker from 'vuejs-datepicker';
export default {
	components:{Datepicker},
	data(){
		return{
			
		}
	},
	props:{
		paramPickUp:{
			type: Object,
		}
	},
	computed:{
		...mapState('transactionList', ['transactionOne', 'AlertKonfPickUp']),
		...mapState('courierList', ['selectedCourier']),

		disabledDates() {
			let date = {
				to: new Date(Date.parse(this.transactionOne.trx_datetime) - 8640000),
				from: new Date(Date.now())
			}
			return date
		},
		serialString() {
			let product = this.transactionOne.products
			let serial = []
			product.forEach(element => {
				let string = ''
				if(element.serial && element.serial != 0){
					string = `${element.name} (${element.code}) : ${element.serial_string} `
					serial.push(string)
				}
				
			});
			return serial
		},
	},
	methods:{
		...mapActions('courierList', ['getCourier']),
		...mapMutations('transactionList', ['setKonfProses' , 'resetAlertKonfPickUp'])
	},

	mounted(){
		this.resetAlertKonfPickUp()
		if(this.transactionOne.trx_shipping_method==0){
			this.getCourier()
		}
	}
}

</script>

<style>
.vdp-datepicker input {
	background-color: #ffffff!important;
}
@media (max-width: 425px){
	.vdp-datepicker {
		padding-bottom:8px;
	}
}
@media (min-width: 320px) and (max-width: 450px) {
	.vdp-datepicker__calendar:nth-child(2), .vdp-datepicker__calendar:nth-child(3), .vdp-datepicker__calendar:nth-child(4){
		width: 243px !important;
		margin-left: 0px;
	}
}
</style>